import { Card } from "@ziolo/ui";

export function CookiesPage() {
  return (
    <Card title="Polityka cookies">
      <div className="legal">
        <p>
          zioło.eu nie ma reklam, analityki ani trackerów trzecich. Są tylko dwa własne
          ciasteczka:
        </p>
        <ul>
          <li>
            <strong>ziolo_session</strong> — 7 dni, sesja po zalogowaniu.
          </li>
          <li>
            <strong>ziolo_wordle_guest</strong> — ok. 400 dni, dzienny Wordle bez konta.
          </li>
        </ul>
        <p>
          Przeglądarka trzyma też lokalnie (nie jako ciasteczka) zamknięcie tego
          komunikatu, statystyki Wordle i opcje Koła fortuny. Czyści je ustawienie
          witryny w przeglądarce.
        </p>
        <p>
          Link „Postaw piwo” otwiera buycoffee.to — płatność (BLIK, Apple Pay, Google
          Pay) i ewentualne ciasteczka operatora są już na ich stronie, nie tutaj.
        </p>
        <p>
          <a href="/">Wróć na zioło.eu</a>
        </p>
      </div>
    </Card>
  );
}
